import { Platform } from "react-native";
import { createPlatformStyles, theme } from "../../theme/theme";

export const { ids, styles } = createPlatformStyles({
  mobile: {
    container: {
      minHeight: theme.height,
      marginLeft: "auto",
      marginRight: "auto",
      ...Platform.select({
        ios: {
          "@media (min-width: 200px)": {
            width: "100%",
            paddingHorizontal: theme.spacing.md,
          },
          "@media (min-width: 385px)": {
            width: "100%",
          },
          "@media (min-width: 700px)": {
            width: 600,
          },
          "@media (min-width: 900px)": {
            width: 600,
          },
          "@media (min-width: 1000px)": {
            width: 600,
          },
          "@media (min-width: 1200px)": {
            width: 600,
          },
        },
        android: {
          "@media (min-width: 200px)": {
            width: "100%",
            paddingHorizontal: theme.spacing.md,
            marginTop: 0,
          },
          "@media (min-width: 385px)": {
            width: "100%",
          },
          "@media (min-width: 700px)": {
            width: 600,
            marginTop: theme.margin.reg,
          },
          "@media (min-width: 900px)": {
            width: 600,
          },
          "@media (min-width: 1000px)": {
            width: 600,
          },
          "@media (min-width: 1200px)": {
            width: 600,
          },
        },
      }),
    },
    docInfoCtr: {
      width: "100%",
      position: "relative",
      zIndex: 9,
      ...Platform.select({
        ios: {
          minWidth: "100%",
        },
        android: {
          minWidth: "100%",
        },
      }),
      marginLeft: "auto",
      marginRight: "auto",
      flex: 1,
      paddingBottom: theme.spacing.xxl2,
    },
    billinImage: {
      width: 285,
      height: 400,
      position: "absolute",
      left: -330,
      top: 100,
      ...Platform.select({
        ios: {
          "@media (min-width: 200px)": {
            display: "none",
          },
          "@media (min-width: 900px)": {
            display: "flex",
          },
        },
        android: {
          "@media (min-width: 200px)": {
            display: "none",
          },
          "@media (min-width: 900px)": {
            display: "flex",
          },
        },
      }),
    },
    paddingRight: {
      paddingRight: theme.spacing.xlg,
    },
    claimDetail: {
      zIndex: -1,
      marginTop: theme.margin.reg,
    },
    RefreshLeft: {
      width: 20,
      height: 20,
      position: "absolute",
      top: "40%",
      left: 0,
    },
    RefreshRight: {
      width: 20,
      height: 20,
      position: "absolute",
      top: "40%",
      right: 0,
    },
    cardScrollar: {
      position: "relative",
      marginTop: theme.spacing.xxl2,
    },
    arrowDisable: {
      width: 20,
      height: 20,
      opacity: 0.5,
    },
    Next: {
      width: 20,
      height: 20,
    },
    Prev: {
      width: 20,
      height: 20,
    },
  },
  web: {
    container: {
      minHeight: theme.height,
      marginLeft: "auto",
      marginRight: "auto",

      maxWidth: 1180,
      "@media (min-width: 200px)": {
        width: "90%",
      },
      "@media (min-width: 700px)": {
        maxWidth: 1180,
      },
      "@media (min-width: 1000px)": {
        maxWidth: 1180,
        marginLeft: "auto",
        marginRight: "auto",
        width: "100%",
      },
    },

    docInfoCtr: {
      width: "100%",
      position: "relative",
      zIndex: 9,

      "@media (min-width: 200px)": {
        width: "100%",
      },
      "@media (min-width: 700px)": {
        width: "70%",
      },

      marginLeft: "auto",
      marginRight: "auto",
      paddingBottom: theme.spacing.xxl2,
      flex: 1,
    },
    billinImage: {
      width: 285,
      height: 400,
      position: "absolute",
      left: -330,
      top: 100,
      "@media (min-width: 200px)": {
        display: "none",
      },
      "@media (min-width: 900px)": {
        display: "block",
      },
    },
    paddingRight: {
      paddingRight: theme.spacing.xlg,
    },
    claimDetail: {
      zIndex: -1,
      marginTop: theme.margin.reg,
    },
    RefreshLeft: {
      width: 20,
      height: 20,
      position: "absolute",
      top: "40%",
      left: 0,
    },
    RefreshRight: {
      width: 20,
      height: 20,
      position: "absolute",
      top: "40%",
      right: 0,
    },
    cardScrollar: {
      position: "relative",
      marginTop: theme.spacing.xxl2,
      "@media (min-width: 200px)": {
        paddingHorizontal: 0,
      },
      "@media (min-width: 700px)": {
        paddingHorizontal: theme.spacing.xlg,
      },
    },
    arrowDisable: {
      width: 20,
      height: 20,
      opacity: 0.5,
      "@media (min-width: 200px)": {
        display: "none",
      },
      "@media (min-width: 700px)": {
        display: "block",
      },
    },
    Next: {
      width: 20,
      height: 20,
      "@media (min-width: 200px)": {
        display: "none",
      },
      "@media (min-width: 700px)": {
        display: "block",
      },
    },
    Prev: {
      width: 20,
      height: 20,
      "@media (min-width: 200px)": {
        display: "none",
      },
      "@media (min-width: 700px)": {
        display: "block",
      },
    },
  },
});
